<template>
  <div class="container-fluid">
    <card>
      <template slot="header">
        <div class="row">
          <div class="col-9">
            <h3><i class="fad fa-handshake"></i> &nbsp;&nbsp;ایجاد جلسه جدید</h3>
          </div>
          <div class="col-3 pt-4">
            شماره جلسه: &nbsp;<span dir="ltr"> {{ Scrum.SessionNumber }}</span>
          </div>
        </div>
        <hr />
      </template>
      <template slot="content">
        <div class="container">
          <div class="row" id="AddScrumSessionBox">
            <div class="col-lg-3 col-12">
              <small>انتخاب نوع جلسه</small>
              <SearchableCombo
                :ClassProps="'required'"
                :edit="false"
                :grp="106"
                :code="null"
                :defaultvalue="Scrum.TblComboGrp106NoeSessioin"
                @ResultCombo="GetResult106"
                :rownumintable="3"
                :action="'TblCrmCombo/GetComboById'"
                :method="'POST'"
                :idinput="'NoeSessionCombo'"
                :keyItem="'NoeSessionCombo'"
                :disabled="false"
              >
              </SearchableCombo>
            </div>
            <div class="col-lg-3 col-12">
              <small id="LbltarixAz"> تاریخ برگذاری جلسه</small>
              <date-picker input-class="required form-control" color="dimgray" v-model="Scrum.SessionDate" clearable :editable="true" placeholder=" تاریخ "></date-picker>
            </div>
            <div class="col-lg-6 col-12">
              <small>موضوع جلسه</small>
              <input type="text" v-model="Scrum.Subject" class="form-control required" />
            </div>
            <div class="col-lg-3 col-12">
              <small id="LbltarixAz"> زمان شروع جلسه</small>
              <date-picker type="time" input-class="required form-control" color="dimgray" v-model="Scrum.TimeStart" clearable :editable="true" placeholder=" زمان شروع "></date-picker>
            </div>
            <div class="col-lg-3 col-12">
              <small id="LbltarixAz"> زمان پایان جلسه</small>
              <date-picker input-class=" form-control" type="time" color="dimgray" v-model="Scrum.TimeEnd" clearable :editable="true" placeholder=" زمان پایان "></date-picker>
            </div>
            <div class="col-lg-6 col-12">
              <small>کاربران حاضر در جلسه</small>

              <div dir="rtl">
                <treeselect
                  name="demo"
                  :multiple="true"
                  :clearable="true"
                  :searchable="true"
                  :disabled="false"
                  :open-on-click="true"
                  :open-on-focus="true"
                  :clear-on-select="true"
                  :close-on-select="false"
                  :always-open="false"
                  :append-to-body="false"
                  :options="options"
                  v-model="USersList"
                  :normalizer="normalizer"
                  @select="Selectuser"
                  @deselect="Deselectuser"
                  value-consists-of="LEAF_PRIORITY"
                >
                  <label slot="option-label" slot-scope="{ labelClassName, node }" :class="labelClassName">{{ node.label }}</label>
                </treeselect>
              </div>
            </div>
          </div>
          <hr />
          <div class="row">
            <div v-if="$session.get('Menu').filter((x) => x.ControlName == 'OpenPreviuosTasks')[0].isMojaz" class="col-md-3 col-12">
              <button @click="ShowUndoneTasks" class="btn btn-light w-100">مشاهده اقدامات باز قبلی</button>
            </div>
            <div v-if="$session.get('Menu').filter((x) => x.ControlName == 'LastSessionTasks')[0].isMojaz" class="col-md-3 col-12">
              <button @click="ShowLastSessionTasks" class="btn btn-light w-100">مشاهده اقدامات جلسه قبل</button>
            </div>
            <div class="col-md-3 col-12"></div>
            <div class="col-md-3 col-12"></div>
          </div>
        </div>
      </template>
    </card>
    <card>
      <template slot="content">
        <div class="container-fluid">
          <div id="AddResultBox" v-if="AddMode" class="container">
            <div>
              <a @click="CancelAdd"><i class="fas fa-times h5 text-danger"></i> </a>
            </div>
            <div class="row">
              <div class="col-lg-6 col-12">
                <small>عنوان اقدام</small>
                <input type="text" v-model="AddScrumSessionResults.TaskSubject" class="form-control required" />
              </div>
              <div class="col-lg-3 col-12">
                <small>اقدام کننده</small>
                <div dir="rtl">
                  <treeselect
                    name="Eghdam"
                    :multiple="true"
                    :clearable="true"
                    :searchable="true"
                    :disabled="false"
                    :open-on-click="true"
                    :open-on-focus="true"
                    :clear-on-select="true"
                    :close-on-select="false"
                    :always-open="false"
                    :append-to-body="false"
                    :options="options"
                    v-model="USersListEghdam"
                    :normalizer="normalizer"
                    @select="SelectuserEghdam"
                    @deselect="DeselectuserEghdam"
                    value-consists-of="LEAF_PRIORITY"
                  >
                    <label slot="option-label" slot-scope="{ labelClassName, node }" :class="labelClassName">{{ node.label }}</label>
                  </treeselect>
                </div>
              </div>
              <div class="col-lg-3 col-12">
                <small>مهلت انجام</small>
                <date-picker input-class="required form-control" auto-submit color="dimgray" v-model="AddScrumSessionResults.DoneDeadline" clearable :editable="true" placeholder=" تاریخ "></date-picker>
              </div>
              <div class="col-lg-6 col-12">
                <small>شرح اقدام</small>
                <textarea name="Des" id="Des" cols="30" rows="3" class="form-control" v-model="AddScrumSessionResults.Des"></textarea>
              </div>
              <div class="col-lg-3 col-12">
                <small>اولویت</small>
                <SearchableCombo
                  :ClassProps="'required'"
                  :defaultvalue="AddScrumSessionResults.TblComboIdGrp14"
                  :edit="false"
                  :grp="14"
                  :code="null"
                  @ResultCombo="GetResultOlaviat"
                  :rownumintable="3"
                  :action="'TblCrmCombo/GetComboById'"
                  :method="'POST'"
                  :idinput="'Olaviat'"
                  :keyItem="'Olaviat'"
                  :disabled="false"
                >
                </SearchableCombo>
              </div>
              <div class="col-lg-3 col-12">
                <small>مربوط به مشتری</small>
                <SearchableCombo
                  :defaultvalue="AddScrumSessionResults.TblCustomerId"
                  :edit="false"
                  :grp="0"
                  :code="null"
                  @ResultCombo="GetResulTblCostomer"
                  :rownumintable="3"
                  :action="'TblCrmCombo/GetCostomerProduct'"
                  :method="'POST'"
                  :idinput="'TblCostomer'"
                  :keyItem="'TblCostomer'"
                  :disabled="false"
                  :ClassProps="'required'"
                >
                </SearchableCombo>
              </div>
            </div>
            <div class="row">
              <div class="col-lg-9 col-12"></div>
              <div class="col-lg-3 col-12">
                <button v-if="EditMode" @click="EditTaskDone" class="btn btn-warning w-100">بروز رسانی اقدام</button>

                <button v-else @click="AddResult" class="btn btn-success w-100">ثبت اقدام</button>
              </div>
            </div>
          </div>
          <div v-else class="row">
            <a @click="DoAdd"
              ><h5><i class="fas fa-plus text-success"></i></h5
            ></a>
            <div class="col-12 mt-4">
              <bnp-grid :Sortable="true" :key="tablekey" :Selectable="false" :action="true" :propsRows="Results" :propsColumn="Columns" :hasRowNum="true">
                <template slot="tblUserid" slot-scope="props">
                  <SearchableCombo :grp="0" :code="null" :rownumintable="3" :defaultvalue="props.props.tblUserid" :action="'TblCrmCombo/GetUserDatails'" :method="'POST'" :idinput="'UserId'" :keyItem="'UserId'" :disabled="true"> </SearchableCombo>
                </template>
                <template slot="action-slot" slot-scope="props">
                  <a v-if="props.props.Id == 12" @click="RemoveTask(props.props)" class="mx-2">
                    <i class="fas fa-times text-danger"></i>
                  </a>
                  <a v-if="props.props.Id == 12" @click="EditTask(props.props)" class="mx-2">
                    <i class="fas fa-pen text-light"></i>
                  </a>
                </template>
              </bnp-grid>
            </div>
            <div class="col-lg-9 col-12 mt-4"></div>
            <div class="col-lg-3 col-12 mt-4">
              <button v-if="SessionEdit" class="btn btn-warning w-100" @click="EditSession">ویرایش جلسه</button>
              <button v-else class="btn btn-success w-100" @click="SubmitSession">ثبت جلسه</button>
            </div>
          </div>
        </div>
      </template>
    </card>
    <modal v-if="IfModal" @Close="CloseModal" :InheritanceTheme="true" :IsFooter="false" :Size="'Lg'">
      <template v-if="IfModal" slot="header">
        <h4 class="d-inline" v-if="IfIsOPen">اقدامات انجام نشده از قبل</h4>
        <h4 class="d-inline" v-else>اقدامات مصوب جلسه قبل</h4>
        <hr />
      </template>
      <template slot="body">
        <div v-if="IfIsOPen" class="row mx-4">
          <div class="col-md-3 col-12">
            <date-picker input-class=" form-control" color="dimgray" v-model="TaskDateAz" clearable :editable="true" placeholder=" مهلت انجام از "></date-picker>
          </div>
          <div class="col-md-3 col-12">
            <date-picker input-class=" form-control" color="dimgray" v-model="TaskDateTa" clearable :editable="true" placeholder=" مهلت انجام تا "></date-picker>
          </div>
          <div class="col-md-3 col-12">
            <button class="btn btn-success w-100" @click="DoFilter">اعمال فیلتر</button>
          </div>
        </div>
        <div class="contaainer p-4">
          <bnp-grid :Sortable="true" :key="TaskTableKey" :Selectable="false" :action="false" :propsRows="ListFilterTaskBefore" :propsColumn="TaskColumns" :hasRowNum="true">
            <template slot="isView" scope="props">
              <span :data-title="props.props.DateView" v-if="props.props.isView" class="fas fa-check-circle-o text-success Pointer"></span>
              <span v-else class="fas fa-times text-danger"></span>
            </template>
            <template slot="done" scope="props">
              <span :data-title="props.props.DateTimeDone" v-if="props.props.done" class="fas fa-check-circle-o text-success"></span>
              <span v-else class="fas fa-times text-danger"></span>
            </template>
          </bnp-grid>
        </div>
      </template>
    </modal>
  </div>
</template>
<script>
import Card from '@/components/Card/Card.vue'
import SearchableCombo from '@/components/Combo/SearchableCombo.vue'
import VuePersianDatetimePicker from 'vue-persian-datetime-picker'
import Treeselect from '@riophae/vue-treeselect'
import BnpGrid from '@/components/BnpGrid/BnpGrid.vue'
import Modal from '@/pages/Modal/Modal.vue'

export default {
  components: { Card, SearchableCombo, datePicker: VuePersianDatetimePicker, Treeselect, BnpGrid, Modal },
  props: ['EditScrum', 'Editusers', 'EditResults'],
  data() {
    return {
      SessionEdit: false,
      TaskTableKey: 0,
      TaskDateAz: '',
      TaskDateTa: '',
      IfModal: false,
      IfIsOPen: false,
      AddMode: false,
      normalizer(node) {
        return {
          id: node.id,
          label: node.name,
        }
      },
      options: [],
      ListTaskBefore: [],
      ListFilterTaskBefore: [],
      tablekey: 0,
      EditMode: false,
      TaskIndex: null,
      Scrum: {
        SessionDate: this.$GetJalaliDate(),
        TimeEnd: '',
        TimeStart: '',
        TblComboGrp106NoeSessioin: null,
        SessionNumber: '',
        tblUserGrpIdLastEdit: null,
        tblUserGrpIdInsert: 3,
        SessionDate: '',
        DateTimeLastEdit: '',
      },
      USersList: [this.$session.get('UserInfo').tblUserId],
      USersListEghdam: [],
      users: [this.$session.get('UserInfo').tblUserId],
      AddScrumSessionResults: {},
      RawAddScrumResult: {
        DoneDeadline: '',
        TaskSubject: '',
        TblComboIdGrp14: null,
        tblUserid: null,
        Id: 12,
        tblScrumSessionId: 4165,
        IsTask: true,
        IsDone: false,
        tblTaskId: 25,
        DateTimeLastEdit: null,
        DateTimeInsert: 0,
        TblUserGrpIdlastedit: null,
        TblUserGrpIdInsert: 11,
        Des: '',
      },
      Results: [],
      Columns: [
        { label: 'موضوع', name: 'TaskSubject', visibility: true },
        { label: 'کاربر اقدام کننده', name: 'tblUserid', visibility: true },
        { label: 'مهلت انجام', name: 'DoneDeadline', visibility: true },
      ],
      TaskColumns: [
        { label: 'کاربر ', name: 'namFam', visibility: true },
        { label: 'موضوع اقدام', name: 'taskSubject', visibility: true },
        { label: 'مهلت انجام', name: 'doneDeadline', visibility: true },
        { label: 'مشاهده شده', name: 'isView', visibility: true },
        { label: 'انجام شده', name: 'done', visibility: true },
        { label: 'نام مشتری', name: 'customerName', visibility: true },
        { label: 'اولویت', name: 'tblComboIdGrp14Name', visibility: true },
      ],
      Results: [],
      ColumnsTaskModal: [
        { label: 'شماره جلسه', name: 'sessionNumber', visibility: true },
        { label: 'موضوع', name: 'subject', visibility: true },
        { label: 'تاریخ جلسه', name: 'sessionDate', visibility: true },
        { label: 'زمان', name: 'time', visibility: true },
        { label: 'نوع جلسه', name: 'noeSession', visibility: true },
      ],
      EghdamUsers: [],
    }
  },
  methods: {
    GetResult106(combo) {
      if (combo.id != null) {
        this.Scrum.TblComboGrp106NoeSessioin = combo.id
        if (!combo.IsDefault) {
          var daxios = { Action: 'ScrumSession/GetSessionNUmber?Id=' + combo.id, Method: 'GET' }
          this.$PostData(daxios).then((result) => {
            this.Scrum.SessionNumber = result.number
          })
        }
      }
    },
    GetResultOlaviat(combo) {
      if (combo.id != null) {
        this.AddScrumSessionResults.TblComboIdGrp14 = combo.id
      }
    },
    GetResultEghdamKonanade(combo) {
      if (combo.id != null) {
        this.AddScrumSessionResults.tblUserid = combo.id
      }
    },
    GetResulTblCostomer(combo) {
      if (combo.id != null) {
        this.AddScrumSessionResults.TblCustomerId = combo.id
      }
    },
    Deselectuser(data) {
      var index = this.users.indexOf(data.id)
      if (index >= 0) {
        this.users.splice(index, 1)
      }
    },
    DeselectuserEghdam(data) {
      var index = this.EghdamUsers.indexOf(data.id)
      if (index >= 0) {
        this.EghdamUsers.splice(index, 1)
      }
    },
    Selectuser(data) {
      this.users.push(data.id)
      console.log(this.users)
    },
    SelectuserEghdam(data) {
      this.EghdamUsers.push(data.id)
    },
    GetUsers() {
      var Dataaxios = { Method: 'POST', Action: 'TblCrmCombo/GetUserDatails', ArryfieldValue: null }
      this.$PostData(Dataaxios).then((data) => {
        this.options = data
      })
    },
    CancelAdd() {
      this.AddMode = false
      this.EditMode = false
      this.TaskIndex = null
    },
    DoAdd() {
      this.AddScrumSessionResults = JSON.parse(JSON.stringify(this.RawAddScrumResult))
      this.AddMode = true
      this.EditMode = false
      this.TaskIndex = null
    },
    AddResult() {
      if (this.$ValidForm('AddResultBox')) {
        this.EghdamUsers.forEach((e) => {
          console.warn(e)
          this.AddScrumSessionResults.tblUserid = e
          this.Results.push(JSON.parse(JSON.stringify(this.AddScrumSessionResults)))
        })
        // this.Results.push(this.AddScrumSessionResults)
        this.AddMode = false
      }
    },
    SubmitSession() {
      if (this.users.length < 1) {
        this.$mySweetDefaultTost('کاربری به عنوان حاضر در جلسه ثبت نشده است', 'هشدار', 'error', 1000)
      } else {
        if (this.$ValidForm('AddScrumSessionBox')) {
          this.$store.state.loading = true
          if (this.Scrum.TimeEnd == '' || this.Scrum.TimeEnd == null) {
            this.Scrum.TimeEnd = this.$GetJalaliDateTime().substring(11)
          }
          var DataAxios = { Method: 'POST', Action: 'ScrumSession', ArryfildValue: { scrum: this.Scrum, users: this.users, Results: this.Results } }
          this.$PostData(DataAxios)
            .then((result) => {
              if (result.stauts == 'success') {
                this.$store.state.loading = false
                this.$mySweetDefaultTost('جلسه با موفقیت ثبت شد ', '', 'success', 1000)
                this.$router.push({ name: 'SessionsList' })
              } else {
                this.$mySweetDefaultTost('خطا در ثبت جلسه', ' ', 'error', 1000)
                this.$store.state.loading = false
              }
            })
            .finally(() => {
              this.$store.state.loading = false
            })
        }
      }
    },
    EditSession() {
      if (this.users.length < 1) {
        this.$mySweetDefaultTost('کاربری به عنوان حاضر در جلسه ثبت نشده است', 'هشدار', 'error', 1000)
      } else {
        if (this.$ValidForm('AddScrumSessionBox')) {
          this.$store.state.loading = true
          if (this.Scrum.TimeEnd == '' || this.Scrum.TimeEnd == null) {
            console.log(this.$GetJalaliDateTime().substring(11))
            this.Scrum.TimeEnd = this.$GetJalaliDateTime().substring(11) + ''
          }
          var DataAxios = { Method: 'POST', Action: 'ScrumSession/Edit', ArryfildValue: { scrum: this.Scrum, users: this.users, Results: this.Results } }
          this.$PostData(DataAxios)
            .then((result) => {
              if (result.stauts == 'success') {
                this.$store.state.loading = false
                this.$mySweetDefaultTost('جلسه با موفقیت ویرایش شد ', '', 'success', 1000)
                this.$router.push({ name: 'SessionsList' })
              } else {
                this.$mySweetDefaultTost('خطا در ویرایش جلسه', ' ', 'error', 1000)
                this.$store.state.loading = false
              }
            })
            .finally(() => {
              this.$store.state.loading = false
            })
        }
      }
    },
    RemoveTask(row) {
      var index = this.Results.findIndex((obj) => obj.DoneDeadline === row.DoneDeadline && obj.tblUserid === row.tblUserid && obj.TaskSubject === row.TaskSubject)
      console.log(index)
      if (index >= 0) {
        this.Results.splice(index, 1)
      }
      this.tablekey++
    },
    EditTask(row) {
      this.TaskIndex = null
      this.AddMode = true
      this.EditMode = true
      this.AddScrumSessionResults = row
      this.TaskIndex = this.Results.findIndex((obj) => obj.DoneDeadline === row.DoneDeadline && obj.tblUserid === row.tblUserid && obj.TaskSubject === row.TaskSubject)
    },
    EditTaskDone() {
      this.Results[this.TaskIndex] = this.AddScrumSessionResults
      this.AddMode = false
      this.EditMode = false
      this.TaskIndex = null
    },
    ShowLastSessionTasks() {
      this.IfIsOPen = false
      this.ListTaskBefore = []
      if (this.Scrum.TblComboGrp106NoeSessioin == null) {
        this.$mySweetDefaultTost('خطا!', 'لطفا ابتدا نوع جلسه را مشخص کنید', 'error', 2000)
      } else {
        var DataAxios = { Action: 'ScrumSession/GetLastSessionTask?ComboId=' + this.Scrum.TblComboGrp106NoeSessioin, Method: 'GET', ArryfildValue: null }
        this.IfModal = true
        this.$PostData(DataAxios).then((result) => {
          this.ListTaskBefore = result.data
          this.ListFilterTaskBefore = JSON.parse(JSON.stringify(result.data))
          this.TaskTableKey++
        })
      }
    },
    ShowUndoneTasks() {
      this.IfIsOPen = true
      this.ListTaskBefore = []
      if (this.Scrum.TblComboGrp106NoeSessioin == null) {
        this.$mySweetDefaultTost('خطا!', 'لطفا ابتدا نوع جلسه را مشخص کنید', 'error', 2000)
      } else {
        var DataAxios = { Action: 'ScrumSession/GetScrumSessionUndoneTasks?ComboId=' + this.Scrum.TblComboGrp106NoeSessioin, Method: 'GET', ArryfildValue: null }
        this.IfModal = true
        this.$PostData(DataAxios).then((result) => {
          this.ListTaskBefore = result.data
          this.ListFilterTaskBefore = JSON.parse(JSON.stringify(result.data))
          this.TaskTableKey++
        })
      }
    },
    CloseModal() {
      this.IfModal = false
    },
    DoFilter() {
      this.ListFilterTaskBefore = JSON.parse(JSON.stringify(this.ListTaskBefore))

      if (this.TaskDateAz.length > 0) {
        this.ListFilterTaskBefore = JSON.parse(JSON.stringify(this.ListFilterTaskBefore.filter((x) => x.doneDeadline >= this.TaskDateAz)))
      }
      if (this.TaskDateTa.length > 0) {
        this.ListFilterTaskBefore = JSON.parse(JSON.stringify(this.ListFilterTaskBefore.filter((x) => x.doneDeadline <= this.TaskDateTa)))
      }
      this.TaskTableKey++
    },
  },
  created() {
    this.GetUsers()
    if (this.EditScrum) {
      this.SessionEdit = true
      this.Scrum = this.EditScrum
      this.USersList = this.Editusers
      this.users = this.Editusers
      this.Results = this.EditResults

      this.Results.forEach((element) => {
        element['tblUserid'] = element.TblUserIdTask
      })
    }
  },
}
</script>
